import { Box, FormControl, MenuItem, Select } from "@mui/material";

// Reusable dropdown component with optional icon and label.
// Useful for selecting from organization or group options in forms.
export function GroupSelect({
  labelText,      // Placeholder or label to show in the dropdown
  labelIcon,      // Icon to be shown with label and selected item
  options,        // Array of dropdown options [{ id, name }]
  isDisabled,     // Boolean to disable dropdown
  formLabel,      // Optional label above dropdown
  handlechange,   // Function to handle onChange
  val,            // Currently selected value
}) {
  // Hide the dropdown arrow if only one option is present
  const NoArrowIcon = () => null;

  return (
    <Box sx={{ minWidth: 200 }}>
      <FormControl fullWidth>
        {/* Optional form label (above the dropdown) */}
        <label htmlFor="">{formLabel}</label>

        <Select
          value={val}
          disabled={isDisabled}
          onChange={handlechange}
          displayEmpty
          IconComponent={options?.length === 1 ? NoArrowIcon : undefined} // Hide arrow if single option
          sx={{
            borderRadius: "12px",
            height: "50px",
            outline: "none",
          }}
          renderValue={(selected) => {
            // Placeholder view when no value is selected
            if (!selected) {
              return (
                <Box
                  display="flex"
                  alignItems="center"
                  sx={{ color: "gray", gap: "20px" }}
                >
                  {labelIcon}
                  <em>{labelText}</em>
                </Box>
              );
            }

            // Display selected value with icon
            return (
              <Box display="flex" alignItems="center" sx={{ gap: "20px" }}>
                {labelIcon}
                {selected}
              </Box>
            );
          }}
        >
          {/* Disabled placeholder option */}
          <MenuItem disabled value="">
            <em>{labelText}</em>
          </MenuItem>

          {/* Map through options to render dropdown items */}
          {options?.map((e) => (
            <MenuItem key={e?.id} value={e?.id}>
              {e?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
